import React from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import formStyle from "../../assets/jss/eclipse/components/formStyle.js";
import Danger from "../Typography/Danger.js";
import { connect } from "react-redux";
import getSymbolFromCurrency from "currency-symbol-map";
import { InputAdornment } from "@material-ui/core";


const ValidationTextField = withStyles(formStyle)(TextField);

export function AmountTextField(props) {
  const disabled = props?.disabled || false;
  const amountFieldTextAlign = props?.template?.pwaAppOptions?.amountFieldTextAlign || 'right';
  const onChange = props?.onChange;
  const onPaste = props?.onPaste;
  const onKeyUp = props?.onKeyUp;
  const inputs = props?.inputs;
  const errors = props?.errors;
  const walletDetailData = props?.walletDetailData;

  const handleInputChange = (event) => {
    onChange(event);
  }

  const handleInputAmountPaste = (event) => {
    onPaste(event);
  }

  const handleInputKeyUp = (event) => {
    onKeyUp(event);
  }

  return (
    <>
      <ValidationTextField
        inputProps={{
          inputMode: 'decimal',
          step: "any",
          style: { textAlign: amountFieldTextAlign }
        }}
        InputProps={{
          startAdornment: <InputAdornment className={"currencyPrefix"}
            position="start">{getSymbolFromCurrency(walletDetailData?.currency || "ZAR")}</InputAdornment>,
        }}
        InputLabelProps={{
          shrink: true,
        }}
        placeholder="0.00"
        disabled={disabled}
        fullWidth
        label="Amount"
        variant="filled"
        id="amount"
        type="amount"
        error={(errors?.amount) ? true : false}
        name="amount"
        value={inputs?.amount ? inputs?.amount : '0.00'}
        onPaste={handleInputAmountPaste}
        onChange={handleInputChange}
        onKeyUp={handleInputKeyUp} />
        {errors?.amount && <Danger><small>{errors?.amount}</small></Danger>}
    </>
  )
}


const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

export default connect(mapStateToProps)(AmountTextField)